import { render, staticRenderFns } from "./familiarity.vue?vue&type=template&id=d7e4d840&scoped=true"
import script from "./familiarity.vue?vue&type=script&lang=ts"
export * from "./familiarity.vue?vue&type=script&lang=ts"
import style0 from "./familiarity.vue?vue&type=style&index=0&id=d7e4d840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e4d840",
  null
  
)

export default component.exports